import { Provider } from '@angular/core';

import { Clock } from './clock';
import { SystemClockService } from './system-clock.service';

export function provideSignageClock(): Provider[] {
  return [SystemClockService, { provide: Clock, useExisting: SystemClockService }];
}
